var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OrderSearch',{on:{"ordersSearch":_vm.load}}),_c('OrderTable',{attrs:{"editable":false,"hide-columns":['Quantity','FillQuantity'],"loading":_vm.loading,"loaded":_vm.loaded,"data":_vm.orders,"ErrorMessage":_vm.ErrorMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }